import Service from "../Service";
const resource = "HmnDistributionControlWorker/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        console.log("filter",dtr);
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    saveMassive(obj, requestID) {
        return Service.post(resource + "saveMassive", obj, {
            params: { requestID: requestID }
        });
    },
};